import { render, staticRenderFns } from "./alertMsg.vue?vue&type=template&id=759a4506"
import script from "./alertMsg.vue?vue&type=script&lang=js"
export * from "./alertMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports